
export enum LateTenderCd {
	LATE_TENDER = 'LateTender',
	NOT_A_LATE_TENDER = 'NotALateTender'}

